export enum ComplianceStatusEnum {
  COMPLIANT = 'COMPLIANT',
  PARTIALLY_COMPLIANT = 'PARTIALLY_COMPLIANT',
  NON_COMPLIANT = 'NON_COMPLIANT',
  NOT_STARTED = 'NOT_STARTED',
}

export enum WorkaroundDefinedType {
  NO_WORKAROUND = 'NO_WORKAROUND',
  INFINITE = 'INFINITE',
  DEFINED_TIME = 'DEFINED_TIME',
}

export const WORKAROUND_TYPES = WorkaroundDefinedType;

export const WORKAROUND_DISPLAY_LABELS: Record<
  BusinessFunctionWorkaround['workaroundDefined'],
  string
> = {
  [WorkaroundDefinedType.NO_WORKAROUND]: 'N/A',
  [WorkaroundDefinedType.DEFINED_TIME]: 'Defined Time',
  [WorkaroundDefinedType.INFINITE]: 'Infinite',
};

export type WorkaroundTimelineCompliance = {
  slaCompliant: ComplianceStatusEnum;
  rtoCompliant: ComplianceStatusEnum;
  mtoCompliant: ComplianceStatusEnum;
  rpoCompliant: ComplianceStatusEnum;
};

export type BusinessFunctionWorkaround = {
  uuid: string;
  businessFunctionId: string;
  businessFunctionName: string;
  itApplicationId: string;
  itApplicationName: string;
  workaroundDefined: WorkaroundDefinedType;
  isNoWorkaroundNeeded: boolean;
  isWorkaroundNeeded: boolean;
  workaroundTimelineCompliance: WorkaroundTimelineCompliance;
  locationId?: string | null;
  runtimeHours?: number | null;
  maxDataLossHours?: number | null;
  workaroundDescription?: string | null;
  createdAt: string;
  updatedAt: string;
  workaroundUpdatedAt: string | null;
  __typename?: 'BusinessFunctionWorkaround';
};

// Stats type
export type BusinessFunctionStats = {
  businessFunctionId: string;
  name: string;
  totalTaggedApplications: number;
  completionPercentage: number;
  applicationsWithWorkarounds: number;
  __typename?: 'BusinessFunctionStats';
};

// API input type
export type SetBusinessFunctionWorkaroundInput = {
  businessFunctionUuid: string;
  itApplicationUuid: string;
  locationUuid?: string;
  isWorkaroundNeeded?: boolean;
  workaroundDefined?: WorkaroundDefinedType;
  runtimeHours?: number;
  maxDataLossHours?: number;
  workaroundDescription?: string;
};

// API response types
export type GetBusinessFunctionWorkaroundStatsResponse = {
  getBusinessFunctionWorkaroundStats: BusinessFunctionStats[];
};

export type GetBusinessFunctionWorkaroundsSummaryResponse = {
  getBusinessFunctionWorkarounds: BusinessFunctionWorkaround[];
};
